import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import loggedUserReducer from './loggedUserReducer';
import towItemsReducer from './towItemsReducer';
import filtersReducer from './filtersReducer';
import companiesReducer from './companiesReducer';
import languageTransReducer from './languageTransReducer';

const rootReducer = combineReducers({
    routing: routerReducer,
    loggedUserState: loggedUserReducer,
    towItemsState: towItemsReducer,
    filtersState: filtersReducer,
    companiesState: companiesReducer,
    languagesState: languageTransReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js